module.exports = __webpack_public_path__ + "img/oms-logo-large.ffdea39d.png";